import { Component, ReactNode, Suspense } from 'react';
import { Routes } from 'react-router-dom';
import i18n from "../i18n";

interface LayoutProps {
    children?: ReactNode;
}

export class Layout extends Component<LayoutProps> {
    static displayName = Layout.name;

    override componentDidMount(): void {
        i18n.changeLanguage();
    }

    override render(): ReactNode {
        // Шапка живёт в маршрутах: NavMenu вешается на публичный слой в App.tsx,
        // у консоли и админ-экранов свои заголовки.
        return (
            <div style={{ minHeight: "100%" }}>
                <Suspense fallback={<Loading />}>
                    <Routes>
                        {this.props.children}
                    </Routes>
                </Suspense>
            </div>
        );
    }
}

function Loading() {
    return (
        <div className='form-page form-page-full'>
            <div className='form-page-container'>
                <div className='console-logo'>Air-link Console Loading...</div>
            </div>
        </div>
    )
}
